import {getPrivateAxios} from '../../libs';

/**
 *
 * @param guide
 */
export const fetchCollectionDelete = async (id: string) => {
  const {data} = await getPrivateAxios().delete<void>(`/collections/${id}`);
  return data;
};
